// @ts-check
import React, { useEffect, useState } from "react"
import Button from "../../../../../components/atoms/Button.atom"
import InputText from "../../../../../components/atoms/InputText.atom"
import Modal from "../../../../../components/atoms/Modal.atom"
import { severities } from "../../../../../consts/common.const"
import useToast from "../../../../../hooks/useToast.hook"
import { updateChatTitle } from "../../../../../services/estimations/estimationAgentChat.service"

const CHAT_TITLE_MAX_LEN = 25

/**
 * @typedef {object} ChatTitleModalProps
 * @property {boolean} visible
 * @property {string | null} chatId
 * @property {string | undefined} initialTitle
 * @property {() => void} onHide
 * @property {(title: string) => void} [onSaved]
 */

/**
 * @param {ChatTitleModalProps} props
 */
export default function ChatTitleModal({
  visible,
  chatId,
  initialTitle,
  onHide,
  onSaved,
}) {
  const { setMessage } = useToast()
  const [titleDraft, setTitleDraft] = useState("")
  const [titleSaving, setTitleSaving] = useState(false)

  useEffect(() => {
    if (!visible) return
    setTitleDraft(
      typeof initialTitle === "string" ?
        initialTitle.trim().slice(0, CHAT_TITLE_MAX_LEN)
      : ""
    )
  }, [initialTitle, visible])

  const handleSaveTitle = async () => {
    if (!chatId) return

    const trimmed = titleDraft.trim().slice(0, CHAT_TITLE_MAX_LEN)
    if (trimmed.length < 1) {
      setMessage(
        severities.error,
        "Título inválido",
        "Escribe entre 1 y 25 caracteres.",
        3500,
        undefined,
        null,
        null
      )
      return
    }

    setTitleSaving(true)
    const res = await updateChatTitle(chatId, trimmed)
    setTitleSaving(false)

    if (!res.success) {
      setMessage(
        severities.error,
        "No se pudo actualizar",
        "Inténtalo de nuevo en unos segundos.",
        4000,
        undefined,
        null,
        null
      )
      return
    }

    onSaved?.(res.title)
    onHide()
  }

  return (
    <Modal
      visible={visible}
      onHide={() => {
        if (!titleSaving) onHide()
      }}
      header="Editar título"
      className="estimation-agent-quick-v3__title-dialog"
      dismissableMask={!titleSaving}
      closable={!titleSaving}
      footer={
        <div className="flex gap-2 justify-content-end">
          <Button
            type="button"
            label="Cancelar"
            className="p-button-text"
            disabled={titleSaving}
            onClick={onHide}
          />
          <Button
            type="button"
            label="Guardar"
            loading={titleSaving}
            onClick={() => handleSaveTitle()}
          />
        </div>
      }
    >
      <div className="flex flex-column gap-2">
        <label
          htmlFor="estimation-agent-quick-v3-title-input"
          className="text-sm"
        >
          Título ({CHAT_TITLE_MAX_LEN} caracteres máx.)
        </label>
        <InputText
          id="estimation-agent-quick-v3-title-input"
          value={titleDraft}
          maxLength={CHAT_TITLE_MAX_LEN}
          onChange={(e) =>
            setTitleDraft(e.target.value.slice(0, CHAT_TITLE_MAX_LEN))
          }
          disabled={titleSaving}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault()
              handleSaveTitle()
            }
          }}
        />
      </div>
    </Modal>
  )
}
